import * as actions from './actions'
import { handleActions, combineActions } from 'redux-actions'
import { Map, List } from 'immutable'

export const integrations = handleActions(
  {
    [combineActions(actions.fetchIntegrationStatesPending, actions.updateIntegrationStatePending)]: (state, action) => {
      return state.set('connectionsStatus', action.type)
    },
    [actions.fetchIntegrationStatesSuccess]: (state, action) => {
      return state
        .set('connections', action.payload)
        .set('connectionsStatus', action.type)
    },
    [actions.updateIntegrationStateSuccess]: (state, action) => {
      return state.set('connections', action.payload)
    },
    [actions.setWordpressV2IntegrationSuccess]: (state, action) => {
      return state.set('connections', action.payload)
    },
    [actions.fetchIntegrationEventsSuccess]: (state, action) => {
      return state.setIn(['events', action.payload.integrationType, 'data'], List(action.payload.data))
        .setIn(['events', action.payload.integrationType, 'paginationLink'], action.payload.link)
        .setIn(['events', action.payload.integrationType, 'status'], actions.fetchIntegrationEventsSuccess.toString())
    },
    [actions.fetchPaginatedIntegrationEventsSuccess]: (state, action) => {
      const existingEvents = state.getIn(['events', action.payload.integrationType, 'data'], List())
      const updatedEvents = action.payload.data.length
        ? existingEvents.push(...action.payload.data)
        : existingEvents

      return state.setIn(['events', action.payload.integrationType, 'data'], updatedEvents)
        .setIn(['events', action.payload.integrationType, 'paginationLink'], action.payload.link)
        .setIn(['events', action.payload.integrationType, 'status'], actions.fetchIntegrationEventsSuccess.toString())
    },
    [actions.destroyIntegrationEvents]: (state, action) => {
      return state.removeIn(['events', action.payload])
    },
    [actions.fetchIntegrationEventsPending]: (state, action) => {
      return state.setIn(['events', action.payload.integrationType, 'status'], actions.fetchIntegrationEventsPending.toString())
    },
    [actions.fetchIntegrationEventsFailed]: (state, action) => {
      return state.setIn(['events', action.payload.integrationType, 'status'], actions.fetchIntegrationEventsFailed.toString())
    },
    [actions.postBusinessEventCsvSuccess]: (state, action) => {
      return state.setIn(['events', action.payload.integrationName, 'csvstatus'], actions.postBusinessEventCsvSuccess.toString())
    },
    [actions.postBusinessEventCsvFailed]: (state, action) => {
      return state.setIn(['events', action.payload.integrationName, 'csvstatus'], actions.postBusinessEventCsvFailed.toString())
    },
    [combineActions(actions.createAccessTokenSuccess,
      actions.createAccessTokenPending,
      actions.createAccessTokenFailed
    )]: (state, action) => {
      return state.setIn(['accessToken', action.payload.integrationName, 'status'], action.type)
    },
    [actions.createAccessTokenFailed]: (state, action) => {
      return state.setIn(['accessToken', action.payload.integrationName, 'error'], action.payload.err)
    },
    [combineActions(
      actions.fetchFacebookSettings,
      actions.fetchFacebookSettingsCancelled,
      actions.fetchFacebookSettingsFailed,
      actions.fetchFacebookSettingsPending,
      actions.fetchFacebookSettingsSuccess,
    )]: (state, action) => state.setIn(['facebookSettings', 'status'], action.type),
    [actions.fetchFacebookSettingsSuccess]: (state, action) => state.setIn(['facebookSettings', 'data'], action.payload),
    [combineActions(
      actions.fetchStripeKeys,
      actions.fetchStripeKeysCancelled,
      actions.fetchStripeKeysFailed,
      actions.fetchStripeKeysPending,
      actions.fetchStripeKeysSuccess,
    )]: (state, action) => state.setIn(['stripeKeys', 'status'], action.type),
    [actions.fetchStripeKeysSuccess]: (state, action) => state.setIn(['stripeKeys', 'data'], action.payload),
    [combineActions(
      actions.fetchOutreachStatus,
      actions.fetchOutreachStatusFailed,
      actions.fetchOutreachStatusPending,
      actions.fetchOutreachStatusSuccess,
    )]: (state, action) => state.setIn(['outreachStatus', 'status'], action.type),
    [actions.fetchOutreachStatusSuccess]: (state, action) => state.setIn(['outreachStatus', 'data'], Map(action.payload)), 
    [combineActions(
      actions.getLeanDataAuthStatusFailed,
      actions.getLeanDataAuthStatusPending
    )]: (state, action) => {
      return state.setIn(['leanDataAuthStatus', 'status'], action.type.toString())
    }, 
    [actions.getLeanDataAuthStatusSuccess] : (state, action) => {
      return state.setIn(['leanDataAuthStatus', 'status'], action.type.toString())
                  .setIn(['leanDataAuthStatus', 'value'], action.payload.authStatus)
    },
    [actions.getLeanDataAuthStatus]: (state, action) => {
      return state
    }, 
  },
  Map()
)

export const wordpressIntegrationDomain = handleActions({
  [actions.setWordpressDomainSuccess]: state => {
    return state.setIn(['error'], false)
  },

  [actions.setWordpressDomain]: (state, action) => {
    return state.setIn(['rootUrl'], action.payload.rootUrl)
      .setIn(['error'], false)
  },

  [actions.fetchWordpressDomainSuccess]: (state, action) => {
    return state.setIn(['rootUrl'], action.payload.rootUrl)
  },

  [actions.setWordpressDomainFailed]: (state, action) => {
    return state.setIn(['error'], action.payload.error)
  }
}, Map({
  rootUrl: '',
  error: false
}))



// WEBPACK FOOTER //
// ./src/scripts/app/modules/integrations/reducers.js